export default __webpack_public_path__ + "static/media/DataRedundancy.f0fbd0c9.png";